// removed by extract-text-webpack-plugin
module.exports = {"icon":"onfido-sdk-ui-crossDevice-CrossDeviceSubmit-icon","uploadList":"onfido-sdk-ui-crossDevice-CrossDeviceSubmit-uploadList","listText":"onfido-sdk-ui-crossDevice-CrossDeviceSubmit-listText"};


//////////////////
// WEBPACK FOOTER
// ./components/crossDevice/CrossDeviceSubmit/style.css
// module id = 391
// module chunks = 1